import React from 'react';
import LegalDocument from './LegalDocument';
import aupContent from './content/acceptable-use-policy.md?raw';

interface AcceptableUsePolicyProps {
  embedded?: boolean;
}

const AcceptableUsePolicy: React.FC<AcceptableUsePolicyProps> = ({ embedded = false }) => {
  return <LegalDocument content={aupContent} embedded={embedded} />;
};

export default AcceptableUsePolicy;
